import { render, staticRenderFns } from "./FormatColorHighlightIcon.vue?vue&type=template&id=234d7a2a"
import script from "./FormatColorHighlightIcon.vue?vue&type=script&lang=js"
export * from "./FormatColorHighlightIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports